import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Typography from '@material-ui/core/Typography';
import { Button,MenuItem, TextField } from '@material-ui/core';
import AddIcon from "@material-ui/icons/Add";
import MUIDataTable from "mui-datatables";
import { withStyles } from '@material-ui/core/styles';
import { withSnackbar } from 'notistack';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import {urlConfig} from './config'
import {Grid} from '@material-ui/core';
import axios from "axios";
import _ from 'lodash';
import ListItemText from '@material-ui/core/ListItemText';

const styles = theme => ({
    container: {
        position: 'relative',
    },
});

// const rootUrl = urlConfig.advisoryBaseUrl;
const bffUrl = urlConfig.bffUrl;

class ContentAdvisoryConfig extends Component {

    constructor(props) {
        super(props)
        this.state = {
            open: false,
            openNewRegionDialog: false,
            symbolsForRegion:[],
            forRegionName:'',
            forRegionCode:'',
            symbolToAdd:'',
            descriptionToAdd:'',
            allowedSymbols:[],
            AUTH_MAM_CONFIG: false,            
            columns: [
                {
                    name: 'regionName',
                    label: 'Region',
                    options: {
                        customBodyRender: (value, tableMeta, updateValue) => {
                            return <p>{value}</p>
                        }
                    }
                },
                {
                    name: 'advisory',
                    label: 'Advisory',
                    options: {
                        filter: false,
                        customBodyRender: (value, tableMeta, updateValue) => (
                            <List disablePadding={true} dense={true} aria-label="secondary mailbox folders">
                                {
                                    value.map((item, index) => (<ListItem key={index}><ListItemText primary={item.symbol + ' - ' + item.description} /></ListItem>))
                                }
                            </List>
                        )
                    }
                },
                {
                    name: 'regionName',
                    label: 'Add New',
                    options: {
                        filter: false,
                        customBodyRender: (value, tableMeta, updateValue) => {
                            return (<Button onClick={() => { this.handleClickNewAdvisory.bind(this)(value,tableMeta.rowData[3]) }} variant={'contained'}><AddIcon />Add New</Button>)
                        }
                    }
                },
                {
                    name: 'regionId',
                    label: 'RegionId',
                    options: {
                        display :false,
                        filter: false,
                        viewColumns: false
                    }
                }
            ],
            newRegions: [],
            tableData: []
        }
    }
    handleClickNewRegion=()=>{
        const existingRegionIds = this.state.tableData.map(data=>data.regionId);
        const newRegions = _.filter(this.state.allRegions, (region) => existingRegionIds.indexOf(region.regionId)<0);
        this.setState({openNewRegionDialog:true, newRegions:newRegions, newRegionEnabled:newRegions.length===0?true:false});
    }
    handleCloseNewRegion=()=>{
        this.clearPopupState();
    }
    handleClickNewAdvisory = (forRegion, forRegionCode) => {
        this.setState({ open: true, forRegionName: forRegion, forRegionCode:forRegionCode });
        this.getNewSymbols(forRegionCode);
        
    }
    handleClose = () => {
        this.clearPopupState();
    };
    
    clearPopupState=()=>{
        this.setState({
            forRegionName:'',
            forRegionCode:'',
            symbolToAdd:'',
            descriptionToAdd:'',
            openNewRegionDialog:false,
            open:false
        })
    }

    getNewSymbols=(regionId)=>{
        let self = this;
        if(self.state.tableData===undefined){
            return [];
        }
        const advisoryArray = self.state.tableData
                .filter(item=>item.regionId==regionId)
                .map(adv => adv.advisory);
        const usedSymbols = advisoryArray[0].map(item=> {
            return item.symbol});
        let symbolsForRegion = self.state.allowedSymbols.filter(item => usedSymbols.indexOf(item)<0);  
        this.setState({'symbolsForRegion':symbolsForRegion});
    }
    
    saveNewAdvisory=(event)=>{
        event.preventDefault();
        let self = this;

        let serverUrl = bffUrl + '/referencedata/advisory';
        const saveAdvisoryInstance = axios.create({
            baseURL: `${serverUrl}`,
            timeout: 1200000,
            headers: {'ACCEPT': 'application/vnd.vuclip.cms.v1+json;charset=UTF-8'}
        });

        self.setState({
            errorMessages: {}
        });

        let data = {};
        let advisory = [];
        let advisoryItem = {};
        advisoryItem['symbol'] = this.state.symbolToAdd;
        advisoryItem['description'] = this.state.descriptionToAdd;
        advisory.push(advisoryItem);
        data['regionId'] = this.state.forRegionCode;
        data['advisory'] = advisory;


        saveAdvisoryInstance.post('',data).then(response=>{
            if(response.status==200){
                self.props.enqueueSnackbar('Ratings saved successfully!', {
                    variant: 'success', anchorOrigin: {
                        vertical: 'bottom',
                        horizontal: 'center',
                    }
                });
                this.clearPopupState();
                this.loadData();
            }
        }).catch(error=>{
            self.props.enqueueSnackbar('Failed to save ratings.', {
                variant: 'warning', anchorOrigin: {
                    vertical: 'bottom',
                    horizontal: 'center',
                }
            });
            console.log(error);
            //alert('error');
        })
    }

    componentDidMount(){
        this.loadAllowedSymbols();
        this.loadData();
        this.loadAllRegions();
    }

    loadAllowedSymbols(){
        let serverUrl = bffUrl + '/referencedata/advisory/all';

        const advisoryInstance = axios.create({
            baseURL: `${serverUrl}`,
            timeout: 120000,
            headers:{'ACCEPT': 'application/vnd.vuclip.cms.v1+json;charset=UTF-8'}
        });

        advisoryInstance.get().then(response => {
            if(response.status==200){
                if(response.data.entity){
                    let symbolsList = [];
                    response.data.entity.map(symbol => {symbolsList.push(symbol.advisorySymbol)});
                    this.setState({'allowedSymbols':symbolsList});
                }else{
                    console.log("invalid resposne from server");
                }
            }
        }).catch(error =>{
//            alert('Error fetching global symbols');
            console.log("error fetching global symbols" ,error);
        })
    }

    loadAllRegions(){
        let serverUrl = bffUrl + '/config/referenceRegions';

        const advisoryInstance = axios.create({
            baseURL: `${serverUrl}`,
            timeout: 120000,
            headers:{'ACCEPT': 'application/vnd.vuclip.cms.v1+json;charset=UTF-8'}
        });

        advisoryInstance.get().then(response => {
            if(response.status==200){
                if(response.data.entity){
                    this.setState({'allRegions':response.data.entity});
                }else{
                    console.log("Failed to fetch all regions from bff");
                }
            }
        }).catch(error =>{
//            alert('Error fetching all regions');
            console.log("error fetching reference regions");
            console.log(error);
        })
    }
    

    loadData(){
        let self = this;

       let serverUrl = bffUrl + '/referencedata/advisory';
       console.log("advisory server url: ",serverUrl);
        const ratingReferenceInstance = axios.create({
            baseURL: `${serverUrl}`,
            timeout: 120000,
            headers: {'ACCEPT': 'application/vnd.vuclip.cms.v1+json;charset=UTF-8'}
        });

        self.setState({
            errorMessages: {}
        });
    
        ratingReferenceInstance.get()
            .then((response)=>{
                if (response.data) {
                    if (response.data.status === "SUCCESS") {
                        if (response.data.entity) {
                            this.setState({tableData:response.data.entity});
                        }
                    }
                }
            })
            .catch(error =>{
                console.log(error);

                //alert('error');
            })
    }

    getMenuItems=()=>
    {
        return this.state.symbolsForRegion.map((code,index)=>{
        return <MenuItem label="Select a symbol" key={index} value={code}>{code}</MenuItem>
        })
    }

    _handleKeyPress = (event) => {
        if (event.key === 'Enter') {
            this.saveNewAdvisory();
       }
    }

    render() {
        let self = this;
        const options = {
            'selectableRows': 'none',
            'print':false,
            'selectableRowsHeader': false,
            customToolbar: function (columnMeta) {
                let toolBar = (
                    <Button aria-label="Create" 
                        variant="contained" 
                        color='primary'
                        onClick={self.handleClickNewRegion}
                        disabled={self.state.newRegionEnabled}
                    >
                    Add New Region
                    </Button>);
                return toolBar
            }
        }
        return (
            <div>
                {/*This is Add New dialog for exisitng regions */}
                <Dialog fullWidth
                    open={this.state.open}
                    onClose={this.handleClose}
                    aria-labelledby="form-dialog-title">
                    <form onSubmit={this.saveNewAdvisory}>
                        <DialogTitle id="form-dialog-title">Add Advisory For - {this.state.forRegionName}</DialogTitle>
                        <DialogContent> 
                            <Grid container direction="row" justify="center" alignItems="center">
                                <Grid item xs={1}></Grid>
                                <Grid item xs={2}>
                                    <TextField select label='Symbol' value={this.state.symbolToAdd} fullWidth required={true} onChange={(event) => {this.setState({symbolToAdd:event.target.value})}}>
                                        {this.getMenuItems()}
                                    </TextField>
                                </Grid>
                                <Grid item xs={2}/>
                                <Grid item xs={6}>
                                    <TextField label='Description' required={true} fullWidth onKeyPress={this._handleKeyPress}  onChange={(event) => {this.setState({descriptionToAdd:event.target.value})}}></TextField>
                                </Grid>
                                <Grid item xs={1}></Grid>
                            </Grid>
                            
                            <br/>
                            <Grid container direction="row" justify="center" alignItems="center">
                                <Grid item xs={1}></Grid>
                                <Grid item xs={10}>
                                <Typography>
                                Please press "Enter" to save new advisory. <br/>
                                Advisory once saved, can not be modified or removed.<br />
                            </Typography>
                            </Grid>
                            <Grid item xs={1}></Grid>
                            </Grid>
                        </DialogContent>
                        <DialogActions>
                            <Button onClick={this.handleClose} color="primary">
                                Cancel
                            </Button>
                            <Button color="primary" type="submit">
                                Save
                            </Button>
                        </DialogActions>
                    </form>
                </Dialog>

                {/* Dialog for Add New Region */}
                <Dialog fullWidth
                    open={this.state.openNewRegionDialog}
                    onClose={this.handleClose}
                    aria-labelledby="form-dialog-title">
                    <form onSubmit={this.saveNewAdvisory}>
                    <DialogTitle id="form-dialog-title">Configure Advisory - {this.state.forRegion}</DialogTitle>
                    <DialogContent>
                        <Grid container direction="row" justify="center" alignItems="center">
                            <Grid item xs={3}>
                                <TextField fullWidth select label='Region'required={true}
                                    onChange={(event)=>{this.setState({forRegionCode:event.target.value.regionId})}}>
                                    { this.state.newRegions.map((region,index)=>(
                                        <MenuItem value={region} key={index}>{region.name}</MenuItem>))
                                    }
                                </TextField>  
                            </Grid>     
                            <Grid item xs={3}>
                                <TextField fullWidth select label='Symbol' required={true} onChange={(event) => {this.setState({symbolToAdd:event.target.value})}}>
                                {
                                    this.state.allowedSymbols.map((code,index)=>{
                                    return <MenuItem key={index} value={code}>{code}</MenuItem>
                                    })
                                }
                                </TextField>
                            </Grid>
                            <Grid item xs={6}>
                                <TextField fullWidth required label='Description' onKeyPress={this._handleKeyPress}  onChange={event => {this.setState({descriptionToAdd: event.target.value})}}></TextField>
                            </Grid>
                        </Grid>
                        <br/>
                        <Typography>
                        Please press "Enter" to save new advisory.<br/>
                        Advisory once saved, can not be modified or removed.<br />
                        </Typography>
                        
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={this.handleCloseNewRegion} color="primary">
                            Cancel
                    </Button>
                        <Button color="primary" type="submit">
                            Save
                        </Button>
                    </DialogActions>
                    </form>
                </Dialog>

                <MUIDataTable
                    title="Content Advisory Configuration"
                    columns={this.state.columns}
                    data={this.state.tableData}
                    options={options}
                ></MUIDataTable>
            </div>
        );
    }
}

ContentAdvisoryConfig.propTypes = {
    classes: PropTypes.object.isRequired,
    theme: PropTypes.object.isRequired,
};

export default withStyles(styles, {withTheme: true})(withSnackbar(ContentAdvisoryConfig));